import styled from "styled-components";

import { IStyledAttributes } from "@ryde/shared";
import { greyMui } from "@ryde/theme";

export const LiveMapMapWrapper = styled.div.attrs<IStyledAttributes>({
  "data-e2e": "live-map-map-wrapper",
})`
  background-color: ${greyMui._100};
  height: 100%;
  min-height: 0;
  display: flex;
  flex-direction: column;
`;

export const LiveMapMapStyled = styled.div.attrs<IStyledAttributes>({
  "data-e2e": "live-map-map",
})`
  flex: 1;
  min-height: 0;
  position: relative;
`;

export const LiveMapMapDataLayer = styled.div<{ $mapDeferred?: boolean }>`
  width: 100%;
  height: 100%;
  visibility: ${({ $mapDeferred }) => ($mapDeferred ? "hidden" : "visible")};
  pointer-events: ${({ $mapDeferred }) => ($mapDeferred ? "none" : "auto")};
`;
